(function() {
  var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
templates['proposalMessageFormPreview.tmpl'] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, stack2, options, functionType="function", escapeExpression=this.escapeExpression, self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "\n	<strong>A donor</strong>\n    ";
  stack2 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.author)),stack1 == null || stack1 === false ? stack1 : stack1.state), {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += " \n";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    	from "
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.author)),stack1 == null || stack1 === false ? stack1 : stack1.state)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\n    ";
  return buffer;
  }

function program4(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "\n	";
  stack2 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.author)),stack1 == null || stack1 === false ? stack1 : stack1.teacherScreenName), {hash:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n";
  return buffer;
  }
function program5(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n		"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.author)),stack1 == null || stack1 === false ? stack1 : stack1.teacherScreenName)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\n	";
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n		";
  stack2 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.author)),stack1 == null || stack1 === false ? stack1 : stack1.familiarDonorGreeting), {hash:{},inverse:self.program(10, program10, data),fn:self.program(8, program8, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.locationAndDonorTeacherRelationship || (depth0 && depth0.locationAndDonorTeacherRelationship)),stack1 ? stack1.call(depth0, (depth0 && depth0.author), true, (depth0 && depth0.undefined), options) : helperMissing.call(depth0, "locationAndDonorTeacherRelationship", (depth0 && depth0.author), true, (depth0 && depth0.undefined), options)))
    + "\n   ";
  return buffer;
  }
function program8(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "					\n			"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.author)),stack1 == null || stack1 === false ? stack1 : stack1.familiarDonorGreeting)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1));
  return buffer;
  }

function program10(depth0,data) {
  
  
  return "A donor";
  }

function program12(depth0,data) {
  
  
  return "\n	responded\n";
  }

  options = {hash:{},data:data};
  stack2 = ((stack1 = helpers.userAvatar || (depth0 && depth0.userAvatar)),stack1 ? stack1.call(depth0, (depth0 && depth0.author), "", options) : helperMissing.call(depth0, "userAvatar", (depth0 && depth0.author), "", options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n<div class=\"activity-description\">\n<p>\n";
  stack2 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.author)),stack1 == null || stack1 === false ? stack1 : stack1.anonymous), {hash:{},inverse:self.program(4, program4, data),fn:self.program(1, program1, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n";
  stack2 = helpers['if'].call(depth0, (depth0 && depth0.teacherResponse), {hash:{},inverse:self.noop,fn:self.program(12, program12, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n</p>\n</div>\n";
  return buffer;
  });
})();